import { lazyLoadComponentFactory } from "@Components/Modules/Helpers";

export type { IOnStickyEvent, IStickTopPanel } from "./StickTopPanel";

export default lazyLoadComponentFactory(
    () => import(/* webpackChunkName: "stick-top-panel" */ "./StickTopPanel"),
);
